import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";

// Libraries
import styled from "styled-components";
import tw from "twin.macro";
import { bgGlobalColor } from "../../pages";

const POST_API =
  "https://w4areim2u3.execute-api.ap-south-1.amazonaws.com/default/braincuber";
export const getBlob = async (fileUri) => {
  const resp = await fetch(fileUri);
  const imageBody = await resp.blob();
  return imageBody;
};

const Container = styled.div`
  ${tw`
    font-roboto
    grid
    grid-rows-1
    grid-cols-1
  `}
`;

const DownloadContainer = styled.div`
  ${tw`
    m-auto
    p-5
    `}
`;

const Button = styled.button`
  ${tw`
    uppercase
    rounded-full
    bg-color-bright
    px-14
    py-6
    text-black
    border-none
    outline-none
    hover:bg-frame-gray
    `}
`;
const sendData = async (name, mobileNo) => {
  try {
    const response = await fetch('http://192.168.29.114:3000/add', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name,
        mobileNo,
      }),
    });

    if (!response.ok) {
      throw new Error(`API call failed with status: ${response.status}`);
    }

    const data = await response.json();
    console.log('API Response:', data);
    return { success: true, data };
  } catch (error) {
    console.error('Error sending data to API:', error);
    return { success: false, error: error.message };
  }
};

const Download = ({ stageRef, contactNumber, name, uploadedLogoImage }) => {
  const [imgBase64, setImgBase64] = useState();
  const [isEnabled, setIsEnabled] = useState(false);

  function getDataUrl(img) {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = img?.width;
    canvas.height = img?.height;
    ctx?.drawImage(img, 0, 0);
    return canvas.toDataURL("image/jpeg");
  }

  useEffect(() => {
    if (uploadedLogoImage) {
      setImgBase64(getDataUrl(uploadedLogoImage));
    }
  }, [uploadedLogoImage]);

  const downloadURI = (uri, name) => {
    const link = document.createElement("a");
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const isValidPhone = (ph) => {
    const isValid = /^\d{10}$/.test(ph || "");
    console.log('Phone validation:', { number: ph, isValid });
    return isValid;
  };

  // Check fields and update button state
  useEffect(() => {
    const hasName = Boolean((name || "").trim());
    const hasValidPhone = isValidPhone(contactNumber);
    
    console.log('Validation state:', {
      name,
      hasName,
      contactNumber,
      hasValidPhone,
    });

    setIsEnabled(hasName && hasValidPhone);
  }, [name, contactNumber]);

  const handleDownload = async () => {
    // if (!isEnabled) return; // guard
    
    // try {
    //   const result = await sendData(name, contactNumber);
    //   if (result.success) {
    //     const dataURL = stageRef.current.toDataURL({ pixelRatio: 4 });
    //     downloadURI(dataURL, "Braincuber.jpg");
    //   } else {
    //     console.error('Failed to save data, download aborted');
    //     alert('Failed to save your information. Please try again.');
    //   }
    // } catch (error) {
    //   console.error('Error in handleDownload:', error);
    //   alert('An error occurred. Please try again.');
    // }

    const dataURL = stageRef.current.toDataURL({ pixelRatio: 4 });
        downloadURI(dataURL, "Braincuber.jpg");
  };

  return (
    <Container>
      <DownloadContainer>
        <Button
          style={{
            // backgroundColor: isEnabled ? bgGlobalColor : "#9aa0a6",
            backgroundColor: bgGlobalColor,
            color: "#fff",
            fontWeight: "500",
            // cursor: isEnabled ? "pointer" : "not-allowed", 
            fontSize: "20px",
            // opacity: isEnabled ? 1 : 0.7,
          }}
          // disabled={!isEnabled}
          onClick={handleDownload}
        >
          DOWNLOAD
        </Button>
      </DownloadContainer>
    </Container>
  );
};

export default Download;
